import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

function NotFound() {
  return (
    <Section>
      <Container>
        <Code
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          404
        </Code>
        <Title
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          Page not found.
        </Title>
        <Subtitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          The page you're looking for doesn't exist or has been moved.
        </Subtitle>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.45 }}
        >
          <HomeLink to="/">
            Go back home
            <svg width="30" height="18" viewBox="0 0 10 6" fill="none">
              <path
                d="M6.71627 0L6.27434 0.441934L8.14928 2.31688H0V2.94189H8.14922L6.27434 4.81678L6.71627 5.25871L9.34566 2.62936L6.71627 0Z"
                fill="currentColor"
              />
            </svg>
          </HomeLink>
        </motion.div>
      </Container>
    </Section>
  );
}

export default NotFound;

const Section = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg);
  transition: background-color 0.3s ease, color 0.3s ease;
`;

const Container = styled.div`
  text-align: center;
`;

const Code = styled(motion.p)`
  font-size: 120px;
  font-weight: 700;
  line-height: 1;
  color: var(--border);
  letter-spacing: -4px;
  margin-bottom: 24px;
`;

const Title = styled(motion.h1)`
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-bottom: 12px;
  color: var(--text);
`;

const Subtitle = styled(motion.p)`
  font-size: 17px;
  color: var(--text-5);
  margin-bottom: 48px;
`;

const HomeLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 14px;
  text-decoration: none;
  font-size: 18px;
  color: var(--text);
  position: relative;
  padding: 18px 40px;
  z-index: 1;

  &::after {
    position: absolute;
    content: "";
    width: 50px;
    height: 50px;
    background: var(--btn-bg);
    z-index: -1;
    display: block;
    left: 0px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    transition: 0.8s ease;
    border-radius: 50%;
  }
  &:hover::after {
    width: 100%;
    height: 100%;
    border-radius: 30px;
  }
`;
